// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ElXJF","right":"styles_right__2spOE"};